import { Extension } from "@tiptap/core";

/**
 * TipTap extension to handle Tab key for indentation
 * Inserts non-breaking spaces when Tab is pressed (survives HTML round-trip)
 */
const TabHandler = Extension.create({
  name: "tabHandler",

  addKeyboardShortcuts() {
    return {
      Tab: () => {
        // Use non-breaking spaces to survive HTML serialization/parsing
        this.editor.commands.insertContent("\u00A0\u00A0\u00A0\u00A0");
        return true;
      },
      "Shift-Tab": () => {
        // Allow browser to move focus backward (avoid keyboard trap)
        return false;
      },
      Escape: () => {
        // Release focus from editor (avoid keyboard trap)
        this.editor.commands.blur();
        return true;
      },
    };
  },
});

export default TabHandler;
